var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tags && _vm.tags.length > 0
    ? _c(
        "div",
        { staticClass: "tags" },
        [
          _vm._l(_vm.tags, function (tag, index) {
            return _c(
              "span",
              { key: index, staticClass: "tag", class: _vm.cssClass },
              [
                _c("span", { staticClass: "tag-text" }, [_vm._v(_vm._s(tag))]),
                _vm.showDelete
                  ? _c("a", {
                      staticClass: "delete is-small",
                      on: {
                        click: function ($event) {
                          return _vm.removeTag(tag, index)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            )
          }),
          _vm.remainingTags > 0
            ? _c("span", { staticClass: "tag", class: _vm.cssClass }, [
                _vm._v(" + " + _vm._s(_vm.remainingTags) + " tags "),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }